import type { ApiConfigProps, ApiRequestHeadersProps } from "./@types";

export const HEADERS_CONFIG: ApiRequestHeadersProps = {
  c_platform: "web",
  c_store: "playgami",
  c_locale: "en_us",
  c_bundle: "WheelOfFortune",
  c_version: "3.95.3", // TODO: needs to check how to get this dynamically
};

export const API_CONFIG: ApiConfigProps = {
  baseURL: import.meta.env.VITE_APP_API_URL || "http://localhost:5123",
  timeout: 10000,
};
